import { type HeadersFunction, json, type LoaderFunctionArgs, type MetaFunction } from '@remix-run/node';
import { useLoaderData } from '@remix-run/react';
import React from 'react';

import BrandsListing from '~/sections/brands-page/BrandsListing';
import { Brand } from '~/types/Brand';
import { apiFetch } from '~/utils/apiFetch';
import { publicPageHeaders } from '~/utils/cacheControl.server';
import { buildPageMeta } from '~/utils/meta';

export interface BrandsLoaderData {
  brands: Brand[];
  API_URL: string;
}

export async function loader({ request }: LoaderFunctionArgs): Promise<Response> {
  const API_URL = process.env.PUBLIC_API_URL;

  const response = await apiFetch(`${API_URL}/api/v2/shop/brands?itemsPerPage=999`, {}, { request });

  if (!response.ok) {
    throw new Response('Failed to load brands', { status: response.status });
  }

  const data = await response.json();

  return json<BrandsLoaderData>({
    brands: data['hydra:member'] || [],
    API_URL: API_URL || '',
  });
}

export const headers: HeadersFunction = ({ parentHeaders }) => publicPageHeaders(parentHeaders);

export const meta: MetaFunction<typeof loader> = ({ matches }) => buildPageMeta('Značky', matches);

const BrandsPageRoute: React.FC = () => {
  const data = useLoaderData<typeof loader>();
  return <BrandsListing serverData={data as BrandsLoaderData} />;
};

export default BrandsPageRoute;
